<mat-form-field [class]="inputClass">

  <mat-label>{{label}}</mat-label>

  <input #searchInput
    matInput
    [errorStateMatcher]="errorStateMatcher"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    type="text"
    (input)="onInput($event.target.value)"
    (blur)="onTouched()">

    <mat-autocomplete #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="onSelect($event.option.value)">

      @if (filteredOptions.length) {
        <!-- Group mode -->
        @if (groupBy) {
          @for (groupName of groupedOptions.keys; track groupName) {
            <mat-optgroup [label]="groupName">
              @for (option of groupedOptions.get(groupName); track option) {
                <mat-option [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-optgroup>
          }
        }
        <!-- List mode -->
        @if (!groupBy) {
          @for (option of filteredOptions; track option) {
            <mat-option [value]="option">
              {{option.name}}
            </mat-option>
          }
        }
      }

      <!-- Empty list -->
      @if (searchInput.value.length >= minSearchLength && !filteredOptions.length) {
        <mat-option [disabled]="true">
          No results found
        </mat-option>
      }

    </mat-autocomplete>

    <div matSuffix>
      @if (isLoading) {
        <app-preloader [type]="preloaderTypes.ICON" [size]="20"></app-preloader>
      }
    </div>

    <!-- Show control errors -->
    <mat-error>
      <app-validation-error [errors]="ngControl.errors"></app-validation-error>
    </mat-error>
  </mat-form-field>
